<template>
  <svg :width="width" :height="width">
    <circle :cx="cx" :cy="cy" :r="r" />
    <text x="50%" y="50%"
      text-anchor="middle"
      dx="-0.02em"
      dy=".35em"
      v-text="text"></text>
    Sorry, your browser does not support inline SVG.
  </svg>
</template>
<script>
export default {
  props:
    [
      'text',
      'size',
    ],

  computed: {
    width() {
      return parseInt(this.size)
    },

    height() {
      return parseInt(this.size)
    },

    cx() {
      return this.width / 2
    },

    cy() {
      return this.height / 2
    },

    r() {
      return this.width / 2
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NumberBadge.vue